<ion-modal class="whats-new-modal" [isOpen]="isOpen$$()" [backdropDismiss]="false" (ionModalDidDismiss)="handleClose()" data-testid="whats-new-modal">
  <ng-template>
    <div class="whats-new">
      <header class="header">
        <button class="close-button" type="button" (click)="handleClose()" [attr.aria-label]="'general.buttons.close' | transloco" data-testid="whats-new-close-button">
          <ion-icon name="close" aria-hidden="true"></ion-icon>
        </button>
      </header>

      <div class="body">
        <app-whats-new-step [step]="currentStepConfig$$()">
          <lib-progress-indicator [flowConfig]="flowConfig" [activeStep]="currentStep$$()"></lib-progress-indicator>
        </app-whats-new-step>
      </div>

      <footer class="footer">
        <lib-app-button class="footer-button" expand="block" fill="clear" [disabled]="isFirstStep$$()" (click)="handleBack()" data-testid="whats-new-back-button">
          {{ 'general.buttons.back' | transloco }}
        </lib-app-button>
        <lib-app-button class="footer-button" expand="block" color="primary" fill="solid" (click)="handleNext()" data-testid="whats-new-next-button">
          {{ (isLastStep$$() ? 'general.buttons.continue' : 'general.buttons.next') | transloco }}
        </lib-app-button>
      </footer>
    </div>
  </ng-template>
</ion-modal>
